'use strict';

var React = require('react');
require('../../../theme/breakpoints.js');
var useIMask = require('../../../hooks/useIMask.js');
require('resize-observer-polyfill');

const useNumberMask = ({ inputRef, value, onChange, min = -Infinity, max = Infinity, thousandsSeparator = '', fractionDigits = 100, fillFractionalZeros = false, radix = ',', }) => {
    const options = React.useMemo(() => ({
        mask: Number,
        min,
        max,
        thousandsSeparator,
        scale: fractionDigits,
        padFractionalZeros: fillFractionalZeros,
        radix,
    }), [min, max, thousandsSeparator, fractionDigits, fillFractionalZeros, radix]);
    const maskRef = useIMask.useIMaskInstance({ inputRef, options });
    useIMask.useIMaskAcceptListener(maskRef, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    React.useCallback(event => onChange(maskRef.current?.unmaskedValue ?? '', event), [onChange]));
    React.useEffect(() => {
        const mask = maskRef.current;
        if (mask && value !== mask.unmaskedValue) {
            mask.unmaskedValue = value;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value]);
};

exports.useNumberMask = useNumberMask;
//# sourceMappingURL=useNumberMask.js.map
